import { Tooltip, useDisclosure } from '@heroui/react'
import { Button } from 'components/ui/Button'
import { MessageSquare } from 'lucide-react'
import SMSTestModal from './SMSTestModal'

export default function SMSTestButton({
  selectedNumber,
  disabled = false,
  highlight = false,
  onSuccess = () => {},
  onClick = null,
  availableNumbers = [],
  isViewPathway = false,
  pathwayId = null,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleButtonClick = () => {
    if (onClick) {
      onClick()
    }
    else {
      onOpen()
    }
  }

  return (
    <>
      <Tooltip content="Test your SMS configuration">
        <Button
          variant="primary"
          size="sm"
          onPress={handleButtonClick}
          isDisabled={disabled}
          id="sms-test-button"
        >
          <MessageSquare size={16} />
          Test SMS
        </Button>
      </Tooltip>

      {!onClick && (
        <SMSTestModal
          isOpen={isOpen}
          onClose={onClose}
          selectedNumber={selectedNumber}
          availableNumbers={availableNumbers}
          onSuccess={onSuccess}
          isViewPathway={isViewPathway}
          pathwayId={pathwayId}
        />
      )}
    </>
  )
}
